import styled, { css } from 'styled-components'

const ContextMenuItem = styled.li<{ $divider?: boolean }>`
  height: 2rem;
  display: inline-flex;
  button {
    font-weight: 400;
    color: var(--dark);
    height: 100%;
    width: 100%;
    line-height: 1.6;
    display: flex;
    justify-content: flex-start !important;
    padding: 0 0.75rem;
    span {
      margin-right: 0.675rem;
    }
  }
  ${({ $divider }) =>
    $divider &&
    css`
      border-bottom: 1px solid var(--greyMedium);
    `}
`

export default ContextMenuItem
